export default __webpack_public_path__ + "static/media/Large-Bread-3.bda3e5bf.jpg";